import Phaser from 'phaser';
import RexUIPlugin from 'phaser3-rex-plugins/templates/ui/ui-plugin.js';
import { GAME_WIDTH, GAME_HEIGHT } from './config/constants';
import { Boot } from './scenes/Boot';
import { Preload } from './scenes/Preload';

/** Hub, Puzzle, Collection подгружаются через dynamic import при переходах, чтобы избежать циклических зависимостей при старте. */

const dpr = Math.min(2, typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1);

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'app',
  backgroundColor: '#282828',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    zoom: 1,
    resizeInterval: 100,
  },
  render: {
    roundPixels: false,
    pixelArt: false,
    antialias: true,
  },
  scene: [Boot, Preload],
  plugins: {
    scene: [{ key: 'rexUI', plugin: RexUIPlugin, mapping: 'rexUI' }],
  },
};

(config as Phaser.Types.Core.GameConfig & { resolution?: number }).resolution = dpr;

const game = new Phaser.Game(config);

function enforceCanvasImageRendering(): void {
  if (typeof document === 'undefined') return;
  const canvas = document.querySelector<HTMLCanvasElement>('#app canvas');
  if (!canvas) return;
  canvas.style.imageRendering = 'auto';
}

if (typeof window !== 'undefined') {
  enforceCanvasImageRendering();
  window.addEventListener('resize', () => {
    game.scale.refresh();
    enforceCanvasImageRendering();
  });
}
